module.exports = __webpack_public_path__ + "c4e5e98cf84febdf9653a9f25d181f3b.pdf";